module.exports = __webpack_public_path__ + "img/Boy_030008.77050591.png";